import { render, staticRenderFns } from "./DeleteBox.vue?vue&type=template&id=36118fc2&"
import script from "./DeleteBox.vue?vue&type=script&lang=js&"
export * from "./DeleteBox.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBox.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports